import { useEffect, useState } from "react";

import { motion, useTransform, useViewportScroll } from "framer-motion";
import ProgressiveImage from "../components/ProgressiveImage";
//Components
// import ScrollForMore from "../components/scrollForMore";
// import Carousel from "../components/Carousel";

//Images
import JoelImageLarge from "../images/joel_LC.jpg";
import JoelImageSmall from "../images/joel_SC.jpg";

//Ease
const transition = { duration: 1, ease: [0.6, 0.01, 0, 0.9] };

const nameLetters = [
  ["J", "o", "e", "l"],
  ["B", "o", "y", "c", "h", "u", "k"],
];

const firstName = {
  animate: {
    transition: {
      delayChildren: 0.6,
      staggerChildren: 0.04,
      staggerDirection: -1,
    },
  },
};

const lastName = {
  animate: {
    transition: {
      delayChildren: 0.6,
      staggerChildren: 0.04,
      staggerDirection: 1,
    },
  },
};

const letter = {
  initial: {
    y: 400,
  },
  animate: {
    y: 0,
    transition: { ...transition },
  },
};

const Spotlight = ({ imageDetails }) => {
  const { scrollYProgress } = useViewportScroll();
  const scale = useTransform(scrollYProgress, [0, 1], [1.05, 0.9]);

  const [scrollable, setScrollable] = useState(false);

  useEffect(() => {
    if (!scrollable) {
      document.querySelector("body").classList.add("no-scroll");
    } else {
      document.querySelector("body").classList.remove("no-scroll");
    }
  }, [scrollable]);

  return (
    <motion.div
      onAnimationComplete={() => setScrollable(true)}
      initial="initial"
      animate="animate"
      exit="exit"
      className="single"
    >
      <div className="container fluid">
        <div className="row center top-row">
          <div className="top">
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{
                opacity: 1,
                y: 0,
                transition: { delay: 0.8, ...transition },
              }}
              className="details"
            >
              <div className="location">
                <span>52.520008</span>
                <span>13.404954</span>
              </div>
              <div className="git">Berlin</div>
            </motion.div>
            <motion.div className="spotlight">
              <motion.span variants={firstName} className="first">
                {nameLetters[0].map((char) => (
                  <motion.span variants={letter}>{char}</motion.span>
                ))}
              </motion.span>
              <motion.span variants={lastName} className="last">
                {nameLetters[1].map((char) => (
                  <motion.span variants={letter}>{char}</motion.span>
                ))}
              </motion.span>
            </motion.div>
          </div>
        </div>
        <div className="row bottom-row">
          <div className="bottom">
            <div className="image-container-single">
              <motion.div
                className="thumbnail-single"
                initial={{
                  y: "-50%",
                  width: imageDetails.width,
                  height: imageDetails.height,
                  overflow: "hidden",
                }}
                animate={{
                  y: "0",
                  width: "100%",
                  height: "800px",
                  transition: { ...transition },
                }}
              >
                <div className="frame-single">
                  <ProgressiveImage
                    src={JoelImageLarge}
                    placeholder={JoelImageSmall}
                  >
                    {(src) => (
                      <motion.img
                        style={{ scale: scale }}
                        initial={{ scale: 2.26, y: "58%", x: "2.7%" }}
                        animate={{
                          scale: 1.05,
                          y: "0%",
                          x: "0",
                          transition: { ...transition },
                        }}
                        src={src}
                        alt="joel boychuk"
                      />
                    )}
                  </ProgressiveImage>
                </div>
              </motion.div>
            </div>
          </div>
          {/* <ScrollForMore /> */}
        </div>
      </div>
      <div className="detailed-information">
        <div className="container">
          <div className="row">
            <h2 className="title">
              A product person with a <br /> programming past.
            </h2>
            <p>
              Your business is your baby and your product is where it shines
              brightest. Give your business its best chance at success with a
              leader who's built what they've shipped. Life isn't static and
              your business isn't boring. What you ship should reflect that.
              Get in touch and get back to what you do best.
              <i> Growing your business</i>. Leave the planning, the people,
              and the product to me.
            </p>
          </div>
        </div>
      </div>
      {/* <Carousel /> */}
    </motion.div>
  );
};

export default Spotlight;
